import React, { useContext, useState } from 'react';
import { Center, Button, Container, Box, Slide } from '@chakra-ui/react';
import { FcManager, FcStatistics } from "react-icons/fc";
import {store} from "../helper/Store";

const Landing = () => {
    const globalState = useContext(store);
    const { dispatch } = globalState;
    const [show, setShow] = useState(true);
    const [navigation, setNavigation] = useState("");

    const handleNavigationChange = (navigation) => {
        setShow(!show);
        setNavigation(navigation);
        dispatch({ type: 'loading' });
    };

    const handleAnimationEnd = () => {
        if ( !show ) {
            dispatch({ type: 'set_navigation', navigation: navigation });
        }
    }
    
    return (
        <Slide
            in={show}
            direction='left'
            onTransitionEnd={handleAnimationEnd}
        >
            <Container
            maxW='container.auto'
            bgColor='gray.100'
            color='#262626'
            position='fixed'
            top='89px'
            bottom={0}
            maxHeight='calc(100vh - 89px)'
            alignContent='center'
            >
                <Center>
                    <Button
                        width={'300px'}
                        size={'lg'}
                        fontSize={'25px'}
                        bgImage='linear-gradient(to bottom, #61d1bb 0px, #61d1bb 100%)'
                        color='white'
                        _hover={{ bgImage: 'linear-gradient(to bottom, #8adbcb 0px, #8adbcb 100%)' }}
                        leftIcon={<FcManager />}
                        onClick={(event) => handleNavigationChange("executive")}
                    >
                        Executive Reports
                    </Button>
                </Center>
                <Box height={'25px'}></Box>
                <Center>
                    <Button
                        width={'300px'}
                        size={'lg'}
                        fontSize={'25px'}
                        bgImage='linear-gradient(to bottom, #61d1bb 0px, #61d1bb 100%)'
                        color='white'
                        _hover={{ bgImage: 'linear-gradient(to bottom, #8adbcb 0px, #8adbcb 100%)' }}
                        leftIcon={<FcStatistics />}
                        onClick={(event) => handleNavigationChange("detail")}
                    >
                        Detailed Reports
                    </Button>
                </Center>
            </Container>
        </Slide>
    );
};

export default Landing;